import {GROUP_CONTACTS_BUTTON_CLICKED} from "./actionTypes";

export function groupContactsButtonClicked(group)
{
    return { type: GROUP_CONTACTS_BUTTON_CLICKED, group: group }
}